import "./FAQ.less"
import ExpandableCard from "../Common/ExpandableCard"
import SectionTitle from "../Common/SectionTitle"
import FAQJson from "../../Configs/JSON/FAQ.json"

const FAQ_CONFIG = FAQJson["SectionConfig"]
const FAQ_DATA1 = FAQJson["data"].filter((v) => v.type === 1)
const FAQ_DATA2 = FAQJson["data"].filter((v) => v.type === 2)
const FAQ_DATAMob = FAQJson["data"]

const FAQ = ({ deviceType, sectionRef }) => {
  return (
    <div className="FAQ_Root RogueContent" ref={sectionRef}>
      <div className="FAQ_Parent">
        <SectionTitle className="Faq_SectionTitle" title={FAQ_CONFIG["title"]} />
        <div className="FAQ_grid_section">
          {deviceType === 1 ? (
            <>
              <ExpandableCard dataSet={FAQJson} componentName={"Faq"} displayIn={0} open={false} device={deviceType} from={"FAQ"} />
            </>
          ) : (
            // <></>
            <ExpandableCard dataSet={FAQJson} componentName={"Faq"} displayIn={0} open={false} device={deviceType} from={"FAQ"} />
          )}
        </div>
      </div>
    </div>
  )
}

export default FAQ
